import Swiper from 'swiper'
import { Autoplay, Navigation } from 'swiper/modules'

export default class Testimonials {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.testimonials--swiper')
    const prevBtn = swiperEl.querySelector('.testimonials--prev')
    const nextBtn = swiperEl.querySelector('.testimonials--next')

    this.swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    })
  }
}